import React from 'react';
import { Container } from './style';
export interface IndicatorZoneMenuProps {
  children: any;
}

const defaultProps = {};

function IndicatorZoneMenu(props: IndicatorZoneMenuProps) {
  return <Container>{props.children}</Container>;
}

IndicatorZoneMenu.defaultProps = defaultProps;

export default IndicatorZoneMenu;
